__turbopack_context__.v({
  "fromParent": "underlineHover-module__E1u_9a__fromParent",
  "parent": "underlineHover-module__E1u_9a__parent",
  "revealed": "underlineHover-module__E1u_9a__revealed",
  "root": "underlineHover-module__E1u_9a__root",
});
